/* eslint-disable prettier/prettier */
/* eslint-disable */

import React from 'react';
import InputMask from 'react-input-mask';
import { InputAdornment } from '@mui/material';
import { Input } from '../../index';
import { IMaskInputController } from './types';

interface IMaskedInput {
  inputController: IMaskInputController,
  error?: boolean;
  multiline?: boolean,
  placeholder?: string,
  startAdornment?: any,
  endAdornment?: any,
  value?: string | number | null,
  mask: string | (string | RegExp)[],
  prefixValue?: string | number | any
}

const MaskedInput: React.FC<IMaskedInput> = ({
  error,
  inputController,
  multiline,
  placeholder,
  startAdornment,
  endAdornment,
  value,
  mask,
  prefixValue
}) => (
  <InputMask
    mask={mask}
    maskPlaceholder={null}
    onChange={(e) => inputController.handleChange(e.target.value)}
    onBlur={(e) => { if (inputController.handleBlur) inputController.handleBlur(e.target.value); }}
    value={value || prefixValue}
  >
    <Input
      error={error}
      placeholder={placeholder}
      disableUnderline
      multiline={multiline}
      startAdornment={startAdornment ? <InputAdornment position="start">{startAdornment}</InputAdornment> : undefined}
      endAdornment={endAdornment ? <InputAdornment position="end">{endAdornment}</InputAdornment> : undefined}
    />
  </InputMask>
);

export default MaskedInput;
